export default __webpack_public_path__ + "images/angle-left_45c78c237b0f64bf7220ae2628ece956.svg";